import { render } from "./PopupSlotComponent.vue?vue&type=template&id=ed26a4c0&scoped=true"
import script from "./PopupSlotComponent.vue?vue&type=script&lang=js"
export * from "./PopupSlotComponent.vue?vue&type=script&lang=js"

import "./PopupSlotComponent.vue?vue&type=style&index=0&id=ed26a4c0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed26a4c0"]])

export default __exports__